import React, { FC } from 'react';
import styled from 'styled-components';
import {
  SingleLineEllipsis,
  Caption01,
  ProductiveHeading07,
} from 'components/styles';

const Wrapper = styled.div`
  display: flex;
`;
const TextWrapper = styled.div`
  padding-left: var(--spacing-03);
  width: 90%;
  ${ProductiveHeading07};
  display: flex;
  flex-direction: column;
  justify-content: center;
  div {
    ${SingleLineEllipsis};
  }
`;
const SecondaryRow = styled.div`
  ${Caption01};
  color: var(--gray-80);
  font-size: var(--font-size-sm);
`;

interface Props {
  avatar: JSX.Element;
  title: string;
  subtitle?: string;
}

export const DescriptionWithAvatar: FC<Props> = ({
  avatar,
  title,
  subtitle,
}) => {
  return (
    <Wrapper>
      {avatar}
      <TextWrapper>
        <div>{title}</div>
        {subtitle ? <SecondaryRow>{subtitle}</SecondaryRow> : null}
      </TextWrapper>
    </Wrapper>
  );
};
